var render, staticRenderFns
import script from "./OwalBannerButton.vue?vue&type=script&lang=js"
export * from "./OwalBannerButton.vue?vue&type=script&lang=js"
import style0 from "./OwalBannerButton.vue?vue&type=style&index=0&id=0414ffec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0414ffec",
  null
  
)

export default component.exports